import { QueryKeys } from '@common/queries/common';
import { useMemo } from 'react';
import { useImmer } from 'use-immer';

import { useGraphQlQuery } from '../../../data/util';
import { TemplateListQuery } from '../query';
import { FilterType, initialFilter, Team, TemplateType } from '../types';

const filterTemplates = (templates: TemplateType[], filter: FilterType) => {
  const isFilterApplied = filter.query || filter.teams.length;
  let queryMatched = true;
  const templatesWithFilterPipelines = filter.query
    ? templates.map((item) => {
        const sqlOrchestratorPipelines = item.sqlOrchestratorPipelines.filter((pipeline) =>
          pipeline.name.toLowerCase().includes(filter.query.toLowerCase())
        );
        return { ...item, sqlOrchestratorPipelines };
      })
    : templates;
  const result = templatesWithFilterPipelines.filter((item) => {
    if (filter.query) {
      queryMatched =
        item.sqlOrchestratorPipelines.length > 0 || item.name.toLowerCase().includes(filter.query.toLowerCase());
    }
    const teamMatched = filter.teams.length > 0 ? filter.teams.some((teamName) => teamName === item.team.name) : true;
    return queryMatched && teamMatched;
  });
  return { templates: result, isFilterApplied };
};

export const useTemplateList = () => {
  const { data, isLoading } = useGraphQlQuery([QueryKeys.Git, QueryKeys.Project, 'template-list'], TemplateListQuery);

  const [filter, setFilter] = useImmer<FilterType>(initialFilter);

  const { templates, teamNames, projectTemplates } = useMemo(() => {
    const projectTemplates = data?.ProphecyTemplates || [];
    const teamMap = new Map<string, Team>();
    projectTemplates.forEach((item) => teamMap.set(item.team._id, item.team));
    const teams = Array.from(teamMap.values());

    const teamNames = teams.map((item) => item.name);
    const { templates } = filterTemplates(projectTemplates, filter);

    return { templates, teamNames, projectTemplates };
  }, [data, filter]);

  return { setFilter, filter, templates, data, isLoading, teamNames, projectTemplates };
};
